<dialog-gala (clickClose)="hideModalOubli()">
  <span gala-dialog-titre>{{translate.instant("MDPOUBLI")}}</span>
  @if (formOubli) {
    <form [formGroup]="formOubli" autocomplete="off">
      <div class="row">
        <div class="col-12">
          <input-gala formControlName="LOGIN" [label]="lgTrad.LOGIN" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input-gala formControlName="MAIL" [label]="lgTrad.MAIL" />
        </div>
      </div>
    </form>
  }
  <div gala-dialog-actions>
    <button mat-stroked-button color="primary" (click)="getMailFromWS()">{{lgTrad.ENR}}</button>
    <button mat-stroked-button color="accent" (click)="hideModalOubli()">{{lgTrad.RET}}</button>
  </div>
</dialog-gala>
